import React from "react";

import { StoreTags } from "@constants";

import { useGetDocument } from "./useGetDocument";

const DEFAULT_TAGS = [
  "Physical Damage",
  "Bad IV",
  "Bad HV",
  "Misaligned Sensor",
];

export function useStoreTags() {
  const fetchedTags = useGetDocument<StoreTags>("store", "tags")[0] as
    | StoreTags
    | undefined;
  const tags = React.useMemo(
    () => (fetchedTags === undefined ? DEFAULT_TAGS : fetchedTags.tags),
    [fetchedTags],
  );
  return tags;
}

const DEBUG_TAGS = [
  "Debug",
  "Failed Skeleton Test",
  "Failed Burn In",
  "Failed MaPSA Test",
  "Failed PreEncap Test",
  "Physical Damage",
  "Bad IV",
  "Bad HV",
  "Misaligned Sensor",
];

export function useStoreDebugTags() {
  const fetchedTags = useGetDocument<StoreTags>("store", "debugTags")[0] as
    | StoreTags
    | undefined;
  const tags = React.useMemo(
    () =>
      fetchedTags === undefined || fetchedTags.tags === undefined
        ? DEBUG_TAGS
        : fetchedTags.tags,
    [fetchedTags],
  );
  return tags;
}
